import { UserRole } from './user-role.model';

interface Right { [permission: string]: boolean; }
interface RolePermission { [role: string]: Right; }
// ToDo: Replace Assigned Labs from App User to User Data
export class AppUser {
  userId: string;
  userName: string;
  firstName: string;
  lastName: string;
  email: string;
  assignedLabs: any;
  roles: UserRole[];
  permissions: UserPermissions;
  userData: UserData;

  public constructor(init?: Partial<AppUser>) {
    Object.assign(this, init);
    this.userData = new UserData();
    this.permissions = new UserPermissions();
  }
}

export class UserPermissions {
  rolePermissions: RolePermission;
}

export class UserData {
  assignedLabNumbers: number[];
  defaultLab: any;
}






// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/security/model/app-user.model.ts